import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddDocumentComponent } from './add-document/add-document.component';
import { SearchDocumentComponent } from './search-document/search-document.component';
import { SearchDocumentSignComponent } from './search-document-sign/search-document-sign.component';
import { SearchDocumentReceiveComponent } from './search-document-receive/search-document-receive.component';


const routes: Routes = [
  { path: '', component: AddDocumentComponent },
  // { path: '', component: SearchDocumentComponent },
  // { path: '', component: SearchDocumentSignComponent },
  // { path: '', component: SearchDocumentReceiveComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentRoutingModule { }
